import defaultBranding from './branding'
import odrgBranding from './branding.odrg'
import { BrandingConfig } from './branding'

// Map of available brandings
const brandings: { [key: string]: BrandingConfig } = {
  default: defaultBranding,
  odrg: odrgBranding,
}

// Get brand from environment variable, fallback to 'default' if not set
const selectedBrand = process.env.REACT_APP_BRAND?.toLowerCase() || 'default'

// Get the selected branding or fallback to default if brand not found
export const activeBranding = brandings[selectedBrand] || brandings.default

// Export the BrandingConfig type
export type { BrandingConfig } from './branding'

// For debugging purposes
if (process.env.NODE_ENV === 'development') {
  console.log(`Using brand configuration: ${selectedBrand}`)
}
